<template>
  <div class="program-cate2">
      <div class="subcate">
        <h3>{{name}}</h3>
        <div class="list-content" v-if="!subSecondLable">
          <div class=" subcate-list" :class="labelFold?'fold':''" ref="labelList" >
            <div class="item" 
                :class="{'active':item.focused}"  
                v-for="(item, index) in showList"
                :key="index"
                @click="changeLabel(item)">
                {{item.name}}
            </div>
          </div>
          <p class="btns" @click="labelMore" v-if="moreBtn">
            <span>{{labelFold?'更多':'收起'}}</span>
            <span class="iconfont " :class="labelFold?'icon-arrow-down':'icon-arrow-up'"></span>
          </p>
        </div>
        <div class="list-content" v-else>
          <div class="list-ii" v-for="(item,index) in showList" :key="index">
            <div class="ii-name" :class="{'active':item.focused}" @click="firstLabel(item)">{{item.name}}</div>
            <div class="subcate-list" :class="labelFold[index]?'fold':''" :ref="'labelList'+index" >
              <div class="item"  :class="{'active':subItem.focused}"  v-for="(subItem, subIndex) in item.subType" :key="subIndex" @click="changeLabel(subItem,'second')">{{subItem.name}}</div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
</template>

<script>
export default {
  name: '',
  props: {
    name:String,
    list:Array,
    subSecondLable:Boolean,
    isSingle:Boolean
  },
  data(){
    return{
      showList:null,
      labelFold:false,
      moreBtn:false,
    }
  },
  mounted() {
  },
  computed:{

  },
  watch:{
    list:{
      handler(newv,oldv){
        if(newv &&newv.length>0){
          this.showList = newv
          if(!this.subSecondLable){
            this.$nextTick(()=>{
            let h = this.$refs.labelList ?this.$refs.labelList.offsetHeight:0;
            if(h>40){
              this.labelFold= true;
              this.moreBtn = true;
            }else{
              this.moreBtn = false;
              this.labelFold = false
            }
          })
          }
        }
      },immediate:true
    }
  },
  methods:{
    labelMore(){
      this.labelFold =!this.labelFold
    },
    //选择一级标签
    firstLabel(e){
      // console.log(e)
      let item = e
      this.list.map(t=>{
        if(t.id == item.id){
          if(!t.focused){
            t.focused = true
            if(t.subType){
              t.subType.map(t2=>{
                t2.focused = true
              })
            }
          }else{
            t.focused = false
            if(t.subType){
              t.subType.map(t2=>{
                t2.focused = false
              })
            }
          }
        } 
      })
      setTimeout(() => {
        this.$emit("change")
      }, 100);
    },

     //选择节目分类
    changeLabel(info,level){
      if(level=='second'){
        this.showList.forEach(t=>{
          t.subType.forEach(q=>{
            if(q.id == info.id){
              q.focused =!q.focused
            }
            let AllFoucsed = t.subType.every(ms=>{ return ms.focused})
            if(AllFoucsed){t.focused = true}
            else{t.focused =false}
          })
        })
        // 判断是否全部选中或全部取消
        
      }else{
        this.showList.forEach(item=>{
          const focused = item.focused
          if (this.isSingle) {
            item.focused = false
            // if (item.id == info.id) {
            //   item.focused = !item.focused
            // }
          }
          if(item.id==info.id){
            item.focused=!focused
          }
        })
        const index = this.showList.findIndex(v => v.focused)
        if (index == -1 && (!this.showList[0].id || this.showList[0].id == -1)) {
          this.showList[0].focused = true
        }
      }
      this.$forceUpdate()
      setTimeout(() => {
        this.$emit("change")
      }, 100);
    },

  },
}
</script>
<style scoped lang="scss">


</style>